<template>
  <div class="generic__banner__component generic__banner__component__banner">
    <!-- <pre> {{initialData}} </pre> -->
    <div id="Frames">
      <!--- OPTION2-->

      <div class="generic__banner_component container--is-maxwidth" :class="'hight--' + initialData.PresentationOption"
        v-if="initialData.PresentationOption === 'Option2'">
        <div class="generic__banner__component__section"
          :class="[initialData.BottomMargin28px === true ? 'margin-bottom' : initialData.TopMargin28px === true ? 'margin-top' : initialData.AddTopAndBottomMargins === true ? 'add-margin-top-bottom' : '']">
          <div :class="initialData.PresentationOption">
            <!-- NOSONAR -->
            <div class="generic__banner__component__text__title"
              v-bind:class="[initialData.TitleFontSize, initialData.DesktopText === '' ? 'margin_title' : '']"
              v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'NotSelected' && !smallScreen">
            </div>
            <div class="generic__banner__component__text__title"
              v-bind:class="[initialData.TitleFontSize, initialData.DesktopText === '' ? 'margin_title' : '']"
              v-if="initialData.TitleAtHnTag != 'NotSelected' && !smallScreen">
              <!-- NOSONAR -->
              <h1 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
              <!-- NOSONAR -->
              <h2 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
              <!-- NOSONAR -->
              <h3 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
            </div>
            <!-- NOSONAR -->
            <div class="generic__banner__component__text__title"
              v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
              v-if="smallScreen && initialData.TitleAtHnTag == 'NotSelected'"></div>
            <div class="generic__banner__component__text__title"
              v-if="smallScreen && initialData.TitleAtHnTag != 'NotSelected'">
              <!-- NOSONAR -->
              <h1
                v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
                v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
                <!-- NOSONAR -->
              <h2
                v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
                v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
                <!-- NOSONAR -->
              <h3
                v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
                v-if="initialData.TitleAtHnTag == 'H3'"> </h3>

            </div>

            <div class="generic__banner__component__image parallax">
              <div class="focal-frames"
                v-if="(!smallScreen || (smallScreen && initialData.EnableMobileVersion === true && initialData.MobileImage === '') || (smallScreen && initialData.EnableMobileVersion === false))">

                <div class="focuspoint focal-frame" :style="getScreenWidth('option2')"
                  :data-focus-x="isRtl === false ? initialData.DesktopFocusX : ''"
                  :data-focus-y="isRtl === false ? initialData.DesktopFocusY : ''">
                  <span class="">
                    <img fetchpriority="high" loading="lazy" class="original" :src="initialData.New_Image" :alt="initialData.New_ImageAlt" />
                  </span>
                </div>
              </div>
              <div class="focal-frames"
                v-if="smallScreen && initialData.EnableMobileVersion === true && initialData.MobileImage !== ''">
                <div class="focuspoint focal-frame" :style="getScreenWidth('option2')"
                :data-focus-x="mobileFocusx(isRtl,initialData.MobileFocusX,initialData.DesktopFocusX,initialData.EnableMobileVersion)"
                :data-focus-y="mobileFocusy(isRtl,initialData.MobileFocusY,initialData.DesktopFocusY,initialData.EnableMobileVersion)">
                  <span class="">
                    <img loading="lazy" class="original"
                      :src="imageMobile(initialData.New_Image, initialData.MobileImage, initialData.EnableMobileVersion)" :alt="altMobile(initialData.New_ImageAlt, initialData.MobileImageAlt, initialData.EnableMobileVersion)" />
                  </span>
                </div>
              </div>
            </div>
            <!-- NOSONAR -->
            <div class="generic__banner__component__text__description" v-html="initialData.DesktopText"
              v-if="!smallScreen"></div>
              <!-- NOSONAR -->
            <div class="generic__banner__component__text__description" v-text="initialData.MobileText"
              v-html="titleMobileDescription(initialData.MobileText, initialData.DesktopText, initialData.EnableMobileVersion)"
              v-if="smallScreen">
            </div>

          </div>
        </div>
      </div>
      <!--- OPTIO2-->
      <!--- OPTION1-->
      <div class="generic__banner_component  container--is-maxwidth" :class="'hight--' + initialData.PresentationOption"
        v-if="initialData.PresentationOption == 'Option1'">
        <div class="generic__banner__component__section"
          :class="[initialData.BottomMargin28px === true ? 'margin-bottom' : initialData.TopMargin28px === true ? 'margin-top' : initialData.AddTopAndBottomMargins === true ? 'add-margin-top-bottom' : '']">
          <div :class="initialData.PresentationOption">
            <!-- NOSONAR -->
            <div class="generic__banner__component__text__title"
              v-bind:class="[initialData.TitleFontSize, initialData.DesktopText === '' ? 'margin_title' : '']"
              v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'NotSelected' && !smallScreen">
            </div>
            <div class="generic__banner__component__text__title"
              v-bind:class="[initialData.TitleFontSize, initialData.DesktopText === '' ? 'margin_title' : '']"
              v-if="initialData.TitleAtHnTag != 'NotSelected' && !smallScreen">
              <!-- NOSONAR -->
              <h1 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
              <!-- NOSONAR -->
              <h2 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
              <!-- NOSONAR -->
              <h3 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
            </div>

            <!-- NOSONAR -->
            <div class="generic__banner__component__text__title"
              v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
              v-if="smallScreen && initialData.TitleAtHnTag == 'NotSelected'"></div>
            <div class="generic__banner__component__text__title"
              v-if="smallScreen && initialData.TitleAtHnTag != 'NotSelected'">
              <!-- NOSONAR -->
              <h1
                v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
                v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
                <!-- NOSONAR -->
              <h2
                v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
                v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
                <!-- NOSONAR -->
              <h3
                v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
                v-if="initialData.TitleAtHnTag == 'H3'"> </h3>

            </div>
            <!-- NOSONAR -->
            <div class="generic__banner__component__text__description" v-html="initialData.DesktopText"
              v-if="!smallScreen"></div>
            <!-- NOSONAR -->
            <div class="generic__banner__component__text__description"
              v-html="titleMobileDescription(initialData.MobileText, initialData.DesktopText, initialData.EnableMobileVersion)"
              v-if="smallScreen"> </div>
            <div class="generic__banner__component__image parallax">
              <div class="focal-frames"
                v-if="(!smallScreen || (smallScreen && initialData.EnableMobileVersion === true && initialData.MobileImage === '') || (smallScreen && initialData.EnableMobileVersion === false))">
                <div class="focuspoint focal-frame" :style="getScreenWidth('option1')"
                  :data-focus-x="isRtl === false ? initialData.DesktopFocusX : ''"
                  :data-focus-y="isRtl === false ? initialData.DesktopFocusY : ''">
                  <span class="">
                    <img fetchpriority="high" loading="lazy" class="original" :src="initialData.New_Image" :alt="initialData.New_ImageAlt"/>
                  </span>
                </div>
              </div>
              <div class="focal-frames"
                v-if="smallScreen && initialData.EnableMobileVersion === true && initialData.MobileImage !== ''">
                <div class="focuspoint focal-frame" :style="getScreenWidth('option1')"
                :data-focus-x="mobileFocusx(isRtl,initialData.MobileFocusX,initialData.DesktopFocusX,initialData.EnableMobileVersion)"
                :data-focus-y="mobileFocusy(isRtl,initialData.MobileFocusY,initialData.DesktopFocusY,initialData.EnableMobileVersion)">
                  <span class="">
                    <img loading="lazy" class="original"
                      :src="imageMobile(initialData.New_Image, initialData.MobileImage, initialData.EnableMobileVersion)" :alt="altMobile(initialData.New_ImageAlt, initialData.MobileImageAlt, initialData.EnableMobileVersion)"/>
                  </span>
                </div>
              </div>

            </div>

          </div>
        </div>
      </div>
      <!--- OPTION1-->
      <!--- OPTION6-->
      <div class="generic__banner_component " :class="'hight--' + initialData.PresentationOption"
        v-if="initialData.PresentationOption == 'Option6'" @click="fullBannerClick()">
        <div :class="initialData.PresentationOption">
          <div class="generic__banner__component__section"
            :class="[initialData.BottomMargin28px === true ? 'margin-bottom' : initialData.TopMargin28px === true ? 'margin-top' : initialData.AddTopAndBottomMargins === true ? 'add-margin-top-bottom' : '']">
            <div class="generic__banner__component__image parallax" :class="initialData.EnableBannerClick ? '--bannerClick':''">
              <div class="focal-frames"
                v-if="(!smallScreen || (smallScreen && initialData.EnableMobileVersion === true && initialData.MobileImage === '') || (smallScreen && initialData.EnableMobileVersion === false))">
                <div class="focuspoint focal-frame" :style="getScreenWidth()"
                  :data-focus-x="isRtl === false ? initialData.DesktopFocusX : ''"
                  :data-focus-y="isRtl === false ? initialData.DesktopFocusY : ''">
                  <span class="">
                    <img fetchpriority="high" loading="lazy" class="original" :src="initialData.New_Image" :alt="initialData.New_ImageAlt"/>
                  </span>
                </div>
              </div>
              <div class="focal-frames"
                v-if="smallScreen && initialData.EnableMobileVersion === true && initialData.MobileImage !== ''">
                <div class="focuspoint focal-frame" :style="getScreenWidth()"
                :data-focus-x="mobileFocusx(isRtl,initialData.MobileFocusX,initialData.DesktopFocusX,initialData.EnableMobileVersion)"
                :data-focus-y="mobileFocusy(isRtl,initialData.MobileFocusY,initialData.DesktopFocusY,initialData.EnableMobileVersion)">
                  <span class="">
                    <img loading="lazy" class="original"
                      :src="imageMobile(initialData.New_Image, initialData.MobileImage, initialData.EnableMobileVersion)" :alt="altMobile(initialData.New_ImageAlt, initialData.MobileImageAlt, initialData.EnableMobileVersion)"/>
                  </span>
                </div>
              </div>

            </div>


          </div>
        </div>
      </div>
      <!--- OPTION6-->
      <!------FullWidth --> <!--- working-->
      <div  v-if="initialData.PresentationOption === 'Option5'" @click="fullBannerClick()"
        :class="['generic__banner --full-width', initialData.TextpositiononImage, initialData.BottomMargin28px === true ? 'margin-bottom' : initialData.TopMargin28px === true ? 'margin-top' : initialData.AddTopAndBottomMargins === true ? 'add-margin-top-bottom' : '', initialData.GradientEnabled === true ? '--gradient' :'', initialData.EnableBannerClick ? '--bannerClick':'']">
        <div class="generic__banner--mobile__title" v-if="smallScreen">
          <!-- NOSONAR -->
          <span
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'NotSelected'">
          </span>
          <div v-if="initialData.TitleAtHnTag != 'NotSelected'"></div>
          <!-- NOSONAR -->
          <h1
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
            <!-- NOSONAR -->
          <h2
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
            <!-- NOSONAR -->
          <h3
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
        </div>
        <div class="generic__banner--image-placeholder" v-if="!smallScreen">
          <div class="focal-frames">
            <div class="focuspoint focal-frame" :style="getScreenWidth()"
              :data-focus-x="isRtl === false ? initialData.DesktopFocusX : ''"
              :data-focus-y="isRtl === false ? initialData.DesktopFocusY : ''">
              <img loading="lazy" class="original" :src="initialData.New_Image" :alt="initialData.New_ImageAlt"/>
            </div>
          </div>
        </div>
        <div class="generic__banner--image-placeholder" v-if="smallScreen">
          <div class="focal-frames">
            <div class="focuspoint focal-frame" :style="getScreenWidth()"
              :data-focus-x="mobileFocusx(isRtl,initialData.MobileFocusX,initialData.DesktopFocusX,initialData.EnableMobileVersion)"
              :data-focus-y="mobileFocusy(isRtl,initialData.MobileFocusY,initialData.DesktopFocusY,initialData.EnableMobileVersion)">
              <span>
                <img fetchpriority="high" loading="lazy" class="original"
                  :src="imageMobile(initialData.New_Image, initialData.MobileImage, initialData.EnableMobileVersion)" :alt="altMobile(initialData.New_ImageAlt, initialData.MobileImageAlt, initialData.EnableMobileVersion)" />
              </span>
            </div>
          </div>
        </div>
        <div
          :class="['generic__banner--content-placeholder', initialData.WhiteColorOption === true ? 'whitecolor-enabled' : '']">
          <div :class="['generic__banner--desktop__title', initialData.TitleFontSize]" v-if="!smallScreen">
            <!-- NOSONAR -->
            <span v-bind:class="[initialData.TitleFontSize, initialData.DesktopText === '' ? 'margin_title' : '']"
              v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'NotSelected'">
            </span>
            <div v-if="initialData.TitleAtHnTag != 'NotSelected'">
              <!-- NOSONAR -->
              <h1 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
              <!-- NOSONAR -->
              <h2 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
              <!-- NOSONAR -->
              <h3 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
            </div>
          </div>
          <!-- NOSONAR -->
          <div class="generic__banner--description" v-html="initialData.DesktopText" v-if="!smallScreen"></div>
          <!-- NOSONAR -->
          <div class="generic__banner--description"
            v-html="titleMobileDescription(initialData.MobileText, initialData.DesktopText, initialData.EnableMobileVersion)"
            v-if="smallScreen"></div>
            <!-- NOSONAR -->
          <div class="generic__banner__cta" v-if="initialData.DesktopCTALabel != '' && !smallScreen && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <a :href="initialData.DesktopCTALink" @click="gaTagging($event,initialData.DesktopCTALabel,initialData.DesktopCTALink)" :class="ctaClass" :target="initialData.DesktopCTANewTab ? '_blank' : '_self'">
              <span class="btn__wrapper">{{ initialData.DesktopCTALabel}}</span>
            </a>
          </div>
          <div class="generic__banner__cta"
            v-if="smallScreen && initialData.MobileCTALabel != '' && initialData.EnableMobileVersion && initialData.EnableDSFService === false && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <!-- NOSONAR -->
            <a :href="initialData.MobileCTALink" @click="gaTagging($event,initialData.MobileCTALabel,initialData.MobileCTALink)" :class="ctaClass" :target="initialData.MobileCTANewTab ? '_blank' : '_self'"><span class="btn__wrapper">
                {{ initialData.MobileCTALabel}}
              </span></a>
          </div>
          <div class="generic__banner__cta"
            v-if="!initialData.EnableRoutineFinder && smallScreen && initialData.DesktopCTALabel != '' && initialData.EnableMobileVersion == false && initialData.EnableDSFService === false && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <!-- NOSONAR -->
            <a :href="initialData.DesktopCTALink" @click="gaTagging($event,initialData.DesktopCTALabel,initialData.DesktopCTALink)" :class="ctaClass" :target="initialData.DesktopCTANewTab ? '_blank' : '_self'"><span class="btn__wrapper">
                {{ initialData.DesktopCTALabel }}
              </span></a>
          </div>
            
          <div class="generic__banner__cta " v-if="smallScreen && initialData.EnableDSFService === true">
            <spotscan-embed :data-tenant="dsfData.Tenant" :data-application="initialData.DSFApplication"
              :data-customer="dsfData.Customer" :data-country="dsfData.Country" :data-environment="dsfData.Environment"
              :data-touchpoint="dsfData.Touchpoint" :data-type="dsfData.Type"
              :data-loadingbg="dsfData.Loadingbackgroundcolor" :data-loadingmsg="dsfData.Loadingmessage"
              csrf-token="$WEBSITE_TOKEN" :switch-ecom="dsfData.Switchecom" :switch-autostart="dsfData.Switchautostart"
              :data-cta-label="ctalable(initialData.MobileCTALabel, initialData.DesktopCTALabel, initialData.EnableMobileVersion)"
              :data-pagecategory="dsfPageCategory" :data-cta="ctaClass" :data-dsf-tagging="dsfTagging"></spotscan-embed>
          </div>
        <!--routine-banner-->
<div v-if="initialData.EnableRoutineFinder === true">
          <button @click="fullWidth_Rb()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class="routineFinderStart cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="fullWidth_Rb()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="routineFinderStart cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="fullWidth_Rb()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="routineFinderStart cta cta--light" >{{initialData.DesktopCTALabel}}</button>
          <routine-finder v-if="showFullWidth_Rb"></routine-finder>
</div>
<!--routine-banner-->
<!--multipopin-->
<div v-if="initialData.EnableMultipurposePopin === true"> 
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="openMultiPopup()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--multipopin-->
<!--EnableNewsletterPopin-->
<div v-if="initialData.EnableNewsletterPopin === true"> 
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="opennewsletterOpen()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--EnableNewsletterPopin-->


        </div>
      </div>
      <!------FullWidth -->

      <!--HalfWidth-->
      <div
        :class="['generic__banner --half-width --right', initialData.BottomMargin28px === true ? 'margin-bottom' : initialData.TopMargin28px === true ? 'margin-top' : initialData.AddTopAndBottomMargins === true ? 'add-margin-top-bottom' : '']"
        v-if="initialData.PresentationOption === 'Option3'">
        <div class="generic__banner--mobile__title" v-if="smallScreen">
          <!-- NOSONAR -->
          <span
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'NotSelected'">
          </span>
          <div v-if="initialData.TitleAtHnTag != 'NotSelected'"></div>
          <!-- NOSONAR -->
          <h1
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
            <!-- NOSONAR -->
          <h2
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
            <!-- NOSONAR -->
          <h3
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
        </div>
        <div class="generic__banner--image-placeholder" v-if="!smallScreen">
          <div class="focal-frames">
            <div class="focuspoint focal-frame" :style="getScreenWidthHalf()"
              :data-focus-x="isRtl === false ? initialData.DesktopFocusX : ''"
              :data-focus-y="isRtl === false ? initialData.DesktopFocusY : ''">
              <img loading="lazy" class="original" :src="initialData.New_Image"  :alt="initialData.New_ImageAlt"/>
            </div>
          </div>
        </div>
        <div class="generic__banner--image-placeholder" v-if="smallScreen">
          <div class="focal-frames">
            <div class="focuspoint focal-frame" :style="getScreenWidthHalf('mobile')"
            :data-focus-x="mobileFocusx(isRtl,initialData.MobileFocusX,initialData.DesktopFocusX,initialData.EnableMobileVersion)"
            :data-focus-y="mobileFocusy(isRtl,initialData.MobileFocusY,initialData.DesktopFocusY,initialData.EnableMobileVersion)">
              <span>
                <img fetchpriority="high" loading="lazy" class="original"
                  :src="imageMobile(initialData.New_Image, initialData.MobileImage, initialData.EnableMobileVersion)" :alt="altMobile(initialData.New_ImageAlt, initialData.MobileImageAlt, initialData.EnableMobileVersion)"/>
              </span>
            </div>
          </div>
        </div>
        <div
          :class="['generic__banner--content-placeholder', initialData.WhiteColorOption === true ? 'whitecolor-enabled' : '']"
          v-if="!smallScreen">
          <div :class="['generic__banner--desktop__title', initialData.TitleFontSize]">
            <!-- NOSONAR -->
            <span v-bind:class="[initialData.TitleFontSize, initialData.DesktopText === '' ? 'margin_title' : '']"
              v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'NotSelected'">
            </span>
            <div v-if="initialData.TitleAtHnTag != 'NotSelected'">
              <!-- NOSONAR -->
              <h1 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
              <!-- NOSONAR -->
              <h2 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
              <!-- NOSONAR -->
              <h3 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
            </div>
          </div>
          <!-- NOSONAR -->
          <div class="generic__banner--description" v-html="initialData.DesktopText"></div>
<!--routine-banner-->
<div v-if="initialData.EnableRoutineFinder === true">
          <button @click="rigHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class="routineFinderStart cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="rigHalfWidth_Rb()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="routineFinderStart cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="rigHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != '' &&  initialData.EnableMobileVersion == false && smallScreen" class="routineFinderStart cta cta--light" >{{initialData.DesktopCTALabel}}</button>
          <routine-finder v-if="showRigHalfWidth_Rb"></routine-finder>
</div>
<!--routine-banner-->
<!--multipopin-->
<div v-if="initialData.EnableMultipurposePopin === true"> 
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="openMultiPopup()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--multipopin-->
<!--EnableNewsletterPopin-->
<div v-if="initialData.EnableNewsletterPopin === true"> 
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="opennewsletterOpen()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--EnableNewsletterPopin-->

          <div class="generic__banner__cta " v-if="initialData.DesktopCTALabel != '' && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <!-- NOSONAR -->
            <a :href="initialData.DesktopCTALink" :class="ctaClass" @click="gaTagging($event,initialData.DesktopCTALabel,initialData.DesktopCTALink)" :target="initialData.DesktopCTANewTab ? '_blank' : '_self'">
              <span class="btn__wrapper">
                {{ initialData.DesktopCTALabel}}
              </span>

            </a>
          </div>
        </div>
        <div class="generic__banner--content-placeholder" v-if="smallScreen">
          <!-- NOSONAR -->
          <div class="generic__banner--description"
            v-html="titleMobileDescription(initialData.MobileText, initialData.DesktopText, initialData.EnableMobileVersion)">
          </div>
          <div class="generic__banner__cta "
            v-if="smallScreen && initialData.MobileCTALabel != '' && initialData.EnableMobileVersion && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <!-- NOSONAR -->
            <a :href="initialData.MobileCTALink" @click="gaTagging($event,initialData.MobileCTALabel,initialData.MobileCTALink)" :class="ctaClass" :target="initialData.MobileCTANewTab ? '_blank' : '_self'"><span class="btn__wrapper">
                {{ initialData.MobileCTALabel}}
              </span></a>
          </div>
          <div class="generic__banner__cta "
            v-if="smallScreen && initialData.EnableMobileVersion == false && initialData.DesktopCTALabel != '' && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <!-- NOSONAR -->
            <a :href="initialData.DesktopCTALink" @click="gaTagging($event,initialData.DesktopCTALabel,initialData.DesktopCTALink)" :class="ctaClass" :target="initialData.DesktopCTANewTab ? '_blank' : '_self'"><span class="btn__wrapper">
                {{ initialData.DesktopCTALabel }}
              </span></a>
          </div>
          <!--routine-banner-->
<div v-if="initialData.EnableRoutineFinder === true">
          <button @click="rigHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class="routineFinderStart cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="rigHalfWidth_Rb()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="routineFinderStart cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="rigHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="routineFinderStart cta cta--light" >{{initialData.DesktopCTALabel}}</button>
          <routine-finder v-if="showRigHalfWidth_Rb"></routine-finder>
</div>
<!--routine-banner-->
<!--multipopin-->
<div v-if="initialData.EnableMultipurposePopin === true"> 
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="openMultiPopup()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--multipopin-->
<!--EnableNewsletterPopin-->
<div v-if="initialData.EnableNewsletterPopin === true"> 
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="opennewsletterOpen()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--EnableNewsletterPopin-->
        </div>
      </div>

      <div
        :class="['generic__banner --half-width --left', initialData.BottomMargin28px === true ? 'margin-bottom' : initialData.TopMargin28px === true ? 'margin-top' : initialData.AddTopAndBottomMargins === true ? 'add-margin-top-bottom' : '']"
        v-if="initialData.PresentationOption === 'Option4'">
        <div class="generic__banner--mobile__title" v-if="smallScreen">
          <!-- NOSONAR -->
          <span
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'NotSelected'">
          </span>
          <div v-if="initialData.TitleAtHnTag != 'NotSelected'"></div>
          <!-- NOSONAR -->
          <h1
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
            <!-- NOSONAR -->
          <h2
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
            <!-- NOSONAR -->
          <h3
            v-html="titleMobileText(initialData.MobileTitle, initialData.DesktopTitle, initialData.EnableMobileVersion)"
            v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
        </div>

        <div
          :class="['generic__banner--content-placeholder', initialData.WhiteColorOption === true ? 'whitecolor-enabled' : '']"
          v-if="!smallScreen">
          <div :class="['generic__banner--desktop__title', initialData.TitleFontSize]">
            <!-- NOSONAR -->
            <span v-bind:class="[initialData.TitleFontSize, initialData.DesktopText === '' ? 'margin_title' : '']"
              v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'NotSelected'">
            </span>
            <div v-if="initialData.TitleAtHnTag != 'NotSelected'">
              <!-- NOSONAR -->
              <h1 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H1'"> </h1>
              <!-- NOSONAR -->
              <h2 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H2'"> </h2>
              <!-- NOSONAR -->
              <h3 v-html="initialData.DesktopTitle" v-if="initialData.TitleAtHnTag == 'H3'"> </h3>
            </div>
          </div>
          <!-- NOSONAR -->
          <div class="generic__banner--description" v-html="initialData.DesktopText"></div> 

<!--routine-banner-->
<div v-if="initialData.EnableRoutineFinder === true">
          <button @click="leftHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class="routineFinderStart cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="leftHalfWidth_Rb()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="routineFinderStart cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="leftHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != '' && initialData.MobileCTALabel == '' && initialData.EnableMobileVersion == false && smallScreen" class="routineFinderStart cta cta--light" >{{initialData.DesktopCTALabel}}</button>
          <routine-finder v-if="showLeftHalfWidth_Rb"></routine-finder>
</div>
<!--routine-banner-->
<!--multipopin-->
<div v-if="initialData.EnableMultipurposePopin === true"> 
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="openMultiPopup()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--multipopin-->
<!--EnableNewsletterPopin-->
<div v-if="initialData.EnableNewsletterPopin === true"> 
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="opennewsletterOpen()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--EnableNewsletterPopin-->
          <div class="generic__banner__cta " v-if="initialData.DesktopCTALabel != '' && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <a :href="initialData.DesktopCTALink" :class="ctaClass" @click="gaTagging($event,initialData.DesktopCTALabel,initialData.DesktopCTALink)" :target="initialData.DesktopCTANewTab ? '_blank' : '_self'">
              <span class="btn__wrapper">
                {{ initialData.DesktopCTALabel }}
              </span>

            </a>
          </div>
        </div>
        <div class="generic__banner--image-placeholder" v-if="!smallScreen">
          <div class="focal-frames">
            <div class="focuspoint focal-frame" :style="getScreenWidthHalf()"
              :data-focus-x="isRtl === false ? initialData.DesktopFocusX : ''"
              :data-focus-y="isRtl === false ? initialData.DesktopFocusY : ''">
              <img loading="lazy" class="original" :src="initialData.New_Image" :alt="initialData.New_ImageAlt"/>
            </div>
          </div>
        </div>
        <div class="generic__banner--image-placeholder" v-if="smallScreen">
          <div class="focal-frames">
            <div class="focuspoint focal-frame" :style="getScreenWidthHalf('mobile')"
            :data-focus-x="mobileFocusx(isRtl,initialData.MobileFocusX,initialData.DesktopFocusX,initialData.EnableMobileVersion)"
            :data-focus-y="mobileFocusy(isRtl,initialData.MobileFocusY,initialData.DesktopFocusY,initialData.EnableMobileVersion)">
              <span>
                <img fetchpriority="high" loading="lazy" class="original"
                  :src="imageMobile(initialData.New_Image, initialData.MobileImage, initialData.EnableMobileVersion)" :alt="altMobile(initialData.New_ImageAlt, initialData.MobileImageAlt, initialData.EnableMobileVersion)"/>
              </span>
            </div>
          </div>
        </div>
        <div class="generic__banner--content-placeholder" v-if="smallScreen">
          <!-- NOSONAR -->
          <div class="generic__banner--description"
            v-html="titleMobileDescription(initialData.MobileText, initialData.DesktopText, initialData.EnableMobileVersion)">
          </div>
          <div class="generic__banner__cta " v-if="initialData.MobileCTALabel != '' && initialData.EnableMobileVersion && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <!-- NOSONAR -->
            <a :href="initialData.MobileCTALink" @click="gaTagging($event,initialData.MobileCTALabel,initialData.MobileCTALink)" :class="ctaClass" :target="initialData.MobileCTANewTab ? '_blank' : '_self'"><span class="btn__wrapper">
                {{ initialData.MobileCTALabel }}
              </span></a>
          </div>
          <div class="generic__banner__cta "
            v-if="initialData.EnableMobileVersion == false && initialData.DesktopCTALabel != '' && !initialData.EnableRoutineFinder && !initialData.EnableMultipurposePopin && !initialData.EnableNewsletterPopin">
            <!-- NOSONAR -->
            <a :href="initialData.DesktopCTALink" @click="gaTagging($event,initialData.DesktopCTALabel,initialData.DesktopCTALink)" :class="ctaClass" :target="initialData.DesktopCTANewTab ? '_blank' : '_self'"><span class="btn__wrapper">
                {{ initialData.DesktopCTALabel }}
              </span></a>
          </div>
            <!--routine-banner-->
<div v-if="initialData.EnableRoutineFinder === true">
          <button @click="leftHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class="routineFinderStart cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="leftHalfWidth_Rb()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="routineFinderStart cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="leftHalfWidth_Rb()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="routineFinderStart cta cta--light" >{{initialData.DesktopCTALabel}}</button>
          <routine-finder v-if="showLeftHalfWidth_Rb"></routine-finder>
</div>
<!--routine-banner-->
<!--multipopin-->
<div v-if="initialData.EnableMultipurposePopin === true"> 
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="openMultiPopup()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="openMultiPopup()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--multipopin-->
<!--EnableNewsletterPopin-->
<div v-if="initialData.EnableNewsletterPopin === true"> 
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != '' && !smallScreen" class=" cta cta--light">{{initialData.DesktopCTALabel}}</button>
          <button @click="opennewsletterOpen()"  v-if="initialData.EnableMobileVersion && smallScreen && initialData.MobileCTALabel != ''"  class="cta cta--light" >{{initialData.MobileCTALabel}}</button>
          <button @click="opennewsletterOpen()" v-if="initialData.DesktopCTALabel != ''  && initialData.EnableMobileVersion == false && smallScreen" class="cta cta--light" >{{initialData.DesktopCTALabel}}</button>
</div>
<!--EnableNewsletterPopin-->
        </div>

      </div>
      <!--HalfWidth-->
    </div>
    
   
  </div>

</template>

<script>
import SpotscanEmbed from '@Feature/SpotscanEmbed/code/Scripts/components/spotscan-embed.vue';
import LoadScript from '@Foundation/loadscript/loadscript';
import routineFinder from '@Feature/RoutineFinder/code/Scripts/components/routine-finder.vue';
import FocusPoint from '@Foundation/jquery.focuspoint';
import { AnalyticsHandler } from '@Foundation/analyticsHandler';


export default {
  name: 'generic-banner',
  components: { SpotscanEmbed, LoadScript, routineFinder },

  props: {
    initialData: { type: Object, required: true },
    dsfData: { type: Object, required: true },
    dsfPageCategory: { type: String, required: true },
    ctaClass: { type: String, default: 'btn' },
    btnTagging: { type: Object, required: true },
	dsfTagging: {type: Object, required: true},
    isRtl: { type: Boolean, default: false }
  },

  data() {
    return {
      showRigHalfWidth_Rb : false,
      showLeftHalfWidth_Rb: false,
      showFullWidth_Rb: false,
      routineFinder:false,
      modulename:this.initialData.DesktopTitle,
      ctaname:this.initialData.DesktopCTALabel,
      smallScreen: !window.matchMedia('(min-width: 1024px)').matches,
      imageData: '',
      screenSize: window.matchMedia('(max-width: 767px)').matches
        ? 'small'
        : window.matchMedia('(min-width: 768px) and (max-width: 1023px)')
          .matches
          ? 'medium'
          : 'large'
    };
  },
  mounted() {
    window.eventBus.$on('routineFinderClose:on', (value) => { 
      setTimeout(() => {
      this.showRigHalfWidth_Rb = value;
      this.showLeftHalfWidth_Rb = value;
      this.showFullWidth_Rb = value;
      }, 300);
    });
    this.$nextTick(() => {
    if ($.fn.focusPoint) {
      $(".focuspoint").focusPoint();
    } else {
      console.warn("FocusPoint not found.");
    }
  });  
    console.log('screen sizessss' + this.smallScreen); 
  },
  methods: {
    /*focusMethod() {
       $('.focuspoint').focusPoint();
    },*/
    opennewsletterOpen(){ 
      let pos = 'generic banner';
      window.eventBus.$emit('newsletterpopup', {postion: pos, show: true});
      this.popinBtnTagging();
     
    },
    openMultiPopup(){
      window.eventBus.$emit('multipopin:on', false);
      this.popinBtnTagging();
    },
    rigHalfWidth_Rb(){
      this.showRigHalfWidth_Rb = true;
      this.popinBtnTagging();
    },
    leftHalfWidth_Rb(){
      this.showLeftHalfWidth_Rb = true;
      this.popinBtnTagging();
    },
    fullWidth_Rb(){
      this.showFullWidth_Rb = true;
      this.popinBtnTagging();
    },
    popinBtnTagging(){
      this.get_modulename();
      this.get_ctaname();
      if((this.initialData.EnableRoutineFinder || this.initialData.EnableNewsletterPopin || this.initialData.EnableMultipurposePopin) && this.initialData.PopinTaggingAttributes){
        AnalyticsHandler.pushDataLayer({
          'event': this.initialData.PopinTaggingAttributes.event,
          'ecommerce': this.initialData.PopinTaggingAttributes.ecommerce,
          'event_name': this.initialData.PopinTaggingAttributes.event_name,
          'eventCategory':  window.wsf.AnalyticsVariables.pageCategory ?  window.wsf.AnalyticsVariables.pageCategory : '' ,
          'eventAction': `${this.initialData.PopinTaggingAttributes.eventAction + this.modulename.replace(/<br\s*\/?>/gi, ' ').replace(/<\/?[^>]+(>|$)/g, "").replace(/\n/g, "").toLowerCase()}`,
          'eventLabel':  `${this.ctaname.replace(/<br\s*\/?>/gi, ' ').replace(/<\/?[^>]+(>|$)/g, "").replace(/\n/g, "").toLowerCase() + this.initialData.PopinTaggingAttributes.eventLabel}`,
          'module_name': this.modulename.replace(/<br\s*\/?>/gi, ' ').replace(/<\/?[^>]+(>|$)/g, "").replace(/\n/g, "").toLowerCase(),
          'cta_name':  this.ctaname.replace(/<br\s*\/?>/gi, ' ').replace(/<\/?[^>]+(>|$)/g, "").replace(/\n/g, "").toLowerCase(),
          'link_url': this.initialData.PopinTaggingAttributes.link_url,
        }); 
      }  
    },
    get_modulename(){ 
      if(!this.smallScreen && this.initialData.DesktopTitle){
        this.modulename = this.initialData.DesktopTitle; 
      }
      else {
        this.modulename = this.initialData.MobileTitle == '' ? this.initialData.DesktopTitle : this.initialData.MobileTitle;
        
      }
      if(!this.modulename) {
          this.modulename = 'none';
      }
    },
    get_ctaname(){
      if(!this.smallScreen && this.initialData.DesktopCTALabel){
        this.ctaname = this.initialData.DesktopCTALabel;
      }
      else {
        this.ctaname = this.initialData.MobileCTALabel == '' ? this.initialData.DesktopCTALabel : this.initialData.MobileCTALabel; 
      }
    },
    getScreenWidthHalf(param=null) {
      let screenWidth = '';
      let height = 256;
      let element = document.getElementById('content');
      let positionInfo = element.getBoundingClientRect();
      let width = positionInfo.width;
      if(param === 'mobile'){
         width = positionInfo.width -48;
      }
      if (this.screenSize == 'small') {
        height = 280;
        screenWidth = window.innerWidth;
        return 'width:' + width + 'px; height:' + height + 'px;';
      } else if (this.screenSize == 'medium') {
        height = 400;
        screenWidth = window.innerWidth;
        return 'width:' + width + 'px; height:' + height + 'px;';
      } else if (this.screenSize == 'large') {
        height = 330;
        screenWidth = 504;
        return 'width:' + screenWidth + 'px; height:' + height + 'px;';
      }
       
    },
    getScreenWidth(param = null) {
      let height = 460;
      let element = document.getElementById('content');
      let positionInfo = element.getBoundingClientRect();
      let width = positionInfo.width;
      if (param === 'option2' || param === 'option1') {
        width = positionInfo.width - 40;
      }
      let screenWidth = '';
      if (this.screenSize == 'small') {
        height = 270;
        screenWidth = window.innerWidth;
        return 'width:' + width + 'px; height:' + height + 'px;';
      } else if (this.screenSize == 'medium') {
        height = 400;
        screenWidth = window.innerWidth;
        return 'width:' + width + 'px; height:' + height + 'px;';
      } else if (this.screenSize == 'large') {
        height = 460;
        if (param === 'option2' || param === 'option1') {
          screenWidth = 1024;
          return 'width:100%; height:' + height + 'px;';
        } else {
          screenWidth = window.innerWidth;
          return 'width:100%; height:' + height + 'px;';
        }


      }
      

    },
    gaTagging(event,ctaname,url) {
      if (this.btnTagging.category === 'error page') {

        window.dataLayer.push({
          event: 'uaevent',
          ecommerce: 'undefined',
          eventLabel: 'return::go back to home',
          eventAction: 'select',
          eventCategory: 'body',
        });
      } else {
        if(this.initialData.EnableShutter) {
          event.preventDefault();
          document.getElementById('loader').style.display = 'block';
          document.getElementById('popupFrame').src = url;
          document.getElementById('popup').style.display = 'block';
          document.querySelector('.shutterpage-overlay').style.display = 'block';
          document.body.classList.add('multipopin-open');
          setTimeout(() => {
            document.querySelector(".btn-close").focus();
          }, 300);          
          document.getElementById('popupFrame').style.display = 'none';
        }
        let eventLable = this.btnTagging.desktoplabel;
        let linkUrl;
        let ctaLink;
        if (!this.smallScreen) {
          eventLable = this.btnTagging.desktoplabel;
        } else {
          eventLable = this.btnTagging.mobilelabel;
        }
        if(this.initialData.EnableShutter) {
          linkUrl = 'shutter page';
          ctaLink = ctaname.toLowerCase() + '::shutter page';
        } else {
          linkUrl = window.origin + url;
          ctaLink = ctaname.toLowerCase() + '::' +window.origin + url;
        }
        window.dataLayer.push({
          event: 'uaevent',
          event_name: 'body_button_click',
          ecommerce: 'undefined',
          eventAction: this.btnTagging.action,
          eventCategory: this.btnTagging.category,
          eventLabel: ctaLink,
          cta_name: ctaname.toLowerCase(),
          link_url: linkUrl,
          module_name: "banner",

        });
      }
    },
    titleMobileText(MobileTitle, DesktopTitle, EnableMobileVersion) {
      let title = '';
      if (this.screenSize === 'medium' || this.screenSize === 'small') {
        if (EnableMobileVersion && MobileTitle != '') {
          title = MobileTitle
        } else if (EnableMobileVersion && MobileTitle == '') {
          title = DesktopTitle;
        } else if (EnableMobileVersion === false) {
          title = DesktopTitle;
        }

      }
      return title;

    },
    titleMobileDescription(MobileDescription, DesktopDescription, EnableMobileVersion) {
      let description = '';
      if (this.screenSize === 'medium' || this.screenSize === 'small') {
        if (EnableMobileVersion && MobileDescription != '') {
          description = MobileDescription
        } else if (EnableMobileVersion && MobileDescription == '') {
          description = DesktopDescription;
        } else if (EnableMobileVersion === false) {
          description = DesktopDescription;
        }

      }
      return description;

    },
    desktopalt(bannerlargealt, cropalt) {
      let altTag = cropalt;
      if (bannerlargealt) {
        altTag = bannerlargealt;
      }
      return altTag;
    },
    mobilealt(cropalt, mobile) {
      let mobileAltTag = cropalt;
      if (mobile) {
        mobileAltTag = mobile;
      }
      return mobileAltTag;

    },
    imageMobile(DesktopCropImageMedium, mobileimage, EnableMobileVersion) {
      let smallImage = '';
      if (EnableMobileVersion && mobileimage !== '') {
        smallImage = mobileimage;
      } else {
        smallImage = DesktopCropImageMedium;
      }

      return smallImage;

    },
    altMobile(New_ImageAlt, MobileImageAlt, EnableMobileVersion) {
      let mobileAlt = '';
      if (EnableMobileVersion && MobileImageAlt !== '') {
        mobileAlt = MobileImageAlt;
      } else {
        mobileAlt = New_ImageAlt;
      }

      return mobileAlt;

    },
    ctalable(mobile, deskstop, EnableMobileVersion) {
      let currentCtaLable = '';
      if (EnableMobileVersion) {
        if (mobile === '') {
          currentCtaLable = deskstop;
        } else {
          currentCtaLable = mobile;
        }
      } else {
        currentCtaLable = deskstop;
      }
      return currentCtaLable;

    },
    bgimage(cropimglarge, cropimgemedium, mobileimage) {
      let imgurl = `background-image:url('${cropimglarge}')`;
      if (this.screenSize === 'medium' || this.screenSize === 'small') {
        if (mobileimage) {
          imgurl = `background-image:url('${mobileimage}')`;
        }
        if (mobileimage == '') {
          imgurl = `background-image:url('${cropimgemedium}')`;
        }
      }
      return imgurl;
    },
    decodeHtml(html) {
      let div = document.createElement("div");
      div.innerHTML = html;
      let datas = div.innerText.replaceAll('\n', ' ');
      return datas;
    },
    mobileFocusx(rtl,mobileFoucs,desktopFocus,mobile){
     let focusx ='';
      if(mobile === true){
        focusx = mobileFoucs;
      }else{
        focusx = desktopFocus;
      }
      if(rtl === true){
        focusx ='';
      }
      return focusx;
    },
    mobileFocusy(rtl,mobileFoucs,desktopFocus,mobile){
      let focusy ='';
      if(mobile === true){
        focusy = mobileFoucs;
      }else{
        focusy = desktopFocus;
      }
      if(rtl === true){
        focusy ='';
      }
      return focusy;
    },
    fullBannerClick(){
      if(this.initialData.EnableBannerClick){
        window.location.href=this.initialData.DesktopCTALink;
      }
    }

  }
};
</script>

<style lang='scss' src="./generic-banner.scss"></style>
<style lang='scss' src="./generic-banner-v2.scss"></style>
<style lang='css' src="./helper-tool.css"></style>
<style lang='css' src="./focuspoint.css"></style>
